import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import store from "../store"

const actions = {
    count: 0,
    auditReference: () => {
        actions.count++
        if (actions.count === 1) {
            const localReference = localStorage.getItem("userReference")
            if (localReference) {
                store.dispatch({ type: "POPULATE_USER_REFERENCE", payload: JSON.parse(localReference) })
            }
            axios.get(process.env.REACT_APP_API_URL + "/api/user/reference", AxiosConfig.configValue())
                .then(res => {
                    if (JSON.stringify(res.data) !== localReference) {
                        localStorage.setItem("userReference", JSON.stringify(res.data))
                        store.dispatch({ type: "POPULATE_USER_REFERENCE", payload: res.data })
                    }
                })
                .catch(err => {
                    //console.log(err)
                    // snackBar({ text: "Failed to audit reference data", type: "error", timeout: 4000 })
                })
        }
    }
}
export default actions